import { render, staticRenderFns } from "./settlementManagement.vue?vue&type=template&id=56434090&scoped=true"
import script from "./settlementManagement.vue?vue&type=script&lang=js"
export * from "./settlementManagement.vue?vue&type=script&lang=js"
import style0 from "./settlementManagement.vue?vue&type=style&index=0&id=56434090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56434090",
  null
  
)

export default component.exports